import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useWillUnmount } from 'rooks';

import useFocusTrap from 'lib/hooks/useFocusTrap';
import { useFirstUserInteraction } from 'lib/hooks';
import { getIsUsageDataAvailable } from 'a/selectors/usageSelectors';
import { getIsChallengeQuest, getWorkshopStep } from 'a/hub/selectors/workshopSelectors';

import useWorkshopSfx from '../../../hooks/useWorkshopSfx';
import { ContinueButton } from '../sharedComponents';
import WeeklyUsage from './WeeklyUsage';
import QuestStatus from './QuestStatus';

const LoginModal = ({ config, closeModal }) => {
  const { playTap } = useWorkshopSfx();
  const isChallengeQuest = useSelector(getIsChallengeQuest);
  const isUsageDataAvailable = useSelector(getIsUsageDataAvailable);
  const anyProgress = useSelector(getWorkshopStep) > 0 || isChallengeQuest;
  const firstUserInteraction = useFirstUserInteraction();

  const clickedRef = useRef(false);
  const timeout = useRef(null);
  const onButtonClick = (e) => {
    if (clickedRef.current) return;
    clickedRef.current = true;
    playTap(true);
    timeout.current = setTimeout(() => {
      firstUserInteraction(e);
      closeModal(e);
    }, 150);
  };

  useWillUnmount(() => {
    clearTimeout(timeout.current);
  });

  const dialogRef = useFocusTrap();

  const Content = isUsageDataAvailable ? WeeklyUsage : QuestStatus;
  const topPosition = isUsageDataAvailable ? 435 : 443;
  const titleId = 'login-modal-title';

  return (
    <div
      ref={dialogRef}
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
      data-testid="login-modal"
      data-dd-action-name="login-modal"
    >
      <Content titleId={titleId} anyProgress={anyProgress} dialogs={config.dialogs} />
      <ContinueButton
        accessibilityLabel="Go To Workshop"
        top={topPosition}
        data-dd-action-name="login-modal:continue"
        onClick={onButtonClick}
      />
    </div>
  );
};

LoginModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  config: PropTypes.shape({
    isSuccess: PropTypes.bool,
    correctCount: PropTypes.number,
    totalCount: PropTypes.number,
    dialogs: PropTypes.array,
  }).isRequired,
};

export default LoginModal;
